import React from 'react';

const TableColumnEditor = ({ field, updateField, moveColumnUp, moveColumnDown }) => (
  <div style={{ marginTop: '15px', padding: '10px', backgroundColor: 'var(--bg)', borderRadius: '4px' }}>
    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', fontSize: '12px', color: 'var(--text-secondary)' }}>
      &#x1F4CA; Konfiguracja Tabeli:
    </label>

    <div style={{ marginBottom: '10px' }}>
      <label style={{ fontSize: '11px', fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
        Kolumny:
      </label>
      {(field.tableConfig?.columns || []).map((column, index) => (
        <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '5px', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Nazwa kolumny"
            value={column.name || ''}
            onChange={(e) => {
              const newColumns = [...(field.tableConfig?.columns || [])];
              newColumns[index] = { ...newColumns[index], name: e.target.value };
              updateField(field.id, { tableConfig: { ...field.tableConfig, columns: newColumns } });
            }}
            style={{ flex: 1, padding: '3px 5px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
          />
          <input
            type="number"
            placeholder="Szeroko&#x15B;ć"
            value={column.width || ''}
            onChange={(e) => {
              const newColumns = [...(field.tableConfig?.columns || [])];
              newColumns[index] = { ...newColumns[index], width: parseInt(e.target.value) || 100 };
              updateField(field.id, { tableConfig: { ...field.tableConfig, columns: newColumns } });
            }}
            style={{ width: '60px', padding: '3px 5px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
          />
          <select
            value={column.dataField || ''}
            onChange={(e) => {
              const newColumns = [...(field.tableConfig?.columns || [])];
              newColumns[index] = { ...newColumns[index], dataField: e.target.value };
              updateField(field.id, { tableConfig: { ...field.tableConfig, columns: newColumns } });
            }}
            style={{ width: '120px', padding: '3px 5px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
          >
            <option value="">-- Wybierz dane --</option>
            <optgroup label="&#x1F4CB; Podstawowe">
              <option value="lp">Lp.</option>
              <option value="nazwa_produktu">Nazwa produktu</option>
              <option value="kod_produktu">Kod produktu</option>
              <option value="ilosc">Ilość</option>
              <option value="jednostka">Jednostka</option>
            </optgroup>
            <optgroup label="&#x1F4B0; Ceny i wartości">
              <option value="cena_jednostkowa_netto">Cena jedn. netto</option>
              <option value="cena_jednostkowa_brutto">Cena jedn. brutto</option>
              <option value="wartosc_netto">Wartość netto</option>
              <option value="wartosc_brutto">Wartość brutto</option>
              <option value="stawka_vat">Stawka VAT</option>
              <option value="kwota_vat">Kwota VAT</option>
            </optgroup>
            <optgroup label="&#x1F4C4; Dane faktury">
              <option value="numer_faktury">Numer faktury</option>
              <option value="numer_paragonu">Numer paragonu</option>
              <option value="data_wystawienia">Data wystawienia</option>
              <option value="data_sprzedazy">Data sprzedaży</option>
              <option value="termin_platnosci">Termin płatności</option>
              <option value="sposob_platnosci">Sposób płatności</option>
            </optgroup>
            <optgroup label="&#x1F3E2; Sprzedawca">
              <option value="sprzedawca_nazwa">Nazwa</option>
              <option value="sprzedawca_adres">Adres</option>
              <option value="sprzedawca_nip">NIP</option>
              <option value="sprzedawca_regon">REGON</option>
              <option value="sprzedawca_numer_konta">Numer konta</option>
            </optgroup>
            <optgroup label="&#x1F3EA; Nabywca">
              <option value="nabywca_nazwa">Nazwa</option>
              <option value="nabywca_adres">Adres</option>
              <option value="nabywca_nip">NIP</option>
              <option value="nabywca_regon">REGON</option>
            </optgroup>
            <optgroup label="&#x1F9EE; Sumy faktury">
              <option value="suma_netto">Suma netto</option>
              <option value="suma_vat">Suma VAT (całkowita)</option>
              <option value="suma_brutto">Suma brutto</option>
              <option value="kwota_slownie">Kwota słownie</option>
            </optgroup>
            <optgroup label="&#x1F3F7;&#xFE0F; VAT wg stawek">
              <option value="vat_23_netto">VAT 23% - netto</option>
              <option value="vat_23_vat">VAT 23% - kwota VAT</option>
              <option value="vat_23_brutto">VAT 23% - brutto</option>
              <option value="vat_8_netto">VAT 8% - netto</option>
              <option value="vat_8_vat">VAT 8% - kwota VAT</option>
              <option value="vat_8_brutto">VAT 8% - brutto</option>
              <option value="vat_5_netto">VAT 5% - netto</option>
              <option value="vat_5_vat">VAT 5% - kwota VAT</option>
              <option value="vat_5_brutto">VAT 5% - brutto</option>
              <option value="vat_0_netto">VAT 0% - netto</option>
              <option value="vat_0_vat">VAT 0% - kwota VAT</option>
              <option value="vat_0_brutto">VAT 0% - brutto</option>
              <option value="vat_zw_netto">VAT zw. - netto</option>
              <option value="vat_zw_vat">VAT zw. - kwota VAT</option>
              <option value="vat_zw_brutto">VAT zw. - brutto</option>
            </optgroup>
            <optgroup label="&#x1F4B3; Płatności">
              <option value="kwota_zaplacona">Kwota zapłacona</option>
              <option value="kwota_do_zaplaty">Kwota do zapłaty</option>
              <option value="status_platnosci">Status płatności</option>
            </optgroup>
          </select>
          <select
            value={column.align || 'left'}
            onChange={(e) => {
              const newColumns = [...(field.tableConfig?.columns || [])];
              newColumns[index] = { ...newColumns[index], align: e.target.value };
              updateField(field.id, { tableConfig: { ...field.tableConfig, columns: newColumns } });
            }}
            style={{ width: '70px', padding: '3px 5px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
          >
            <option value="left">L</option>
            <option value="center">C</option>
            <option value="right">R</option>
          </select>
          <button
            onClick={() => moveColumnUp(field.id, index)}
            disabled={index === 0}
            style={{
              padding: '4px 10px',
              backgroundColor: index === 0 ? 'var(--border)' : 'var(--success)',
              color: '#fff' , fontSize: '11px',
              cursor: index === 0 ? 'not-allowed' : 'pointer',
            }}
            title="Przesue kolumnę w górę"
          >
            &#x2191;
          </button>
          <button
            onClick={() => moveColumnDown(field.id, index)}
            disabled={index === (field.tableConfig?.columns || []).length - 1}
            style={{
              padding: '4px 10px',
              backgroundColor: index === (field.tableConfig?.columns || []).length - 1 ? 'var(--border)' : 'var(--success)',
              color: '#fff' , fontSize: '11px',
              cursor: index === (field.tableConfig?.columns || []).length - 1 ? 'not-allowed' : 'pointer',
            }}
            title="Przesue kolumnę w dół"
          >
            &#x2193;
          </button>
          <button
            onClick={() => {
              const newColumns = [...(field.tableConfig?.columns || [])];
              newColumns.splice(index, 1);
              updateField(field.id, { tableConfig: { ...field.tableConfig, columns: newColumns } });
            }}
            style={{ padding: '4px 10px',  border: '1px solid var(--danger)', color: 'var(--danger)' , fontSize: '11px', cursor: 'pointer' }}
          >
            &#x2715;
          </button>
        </div>
      ))}

      <button
        onClick={() => {
          const newColumns = [
            ...(field.tableConfig?.columns || []),
            { name: 'Nowa kolumna', width: 100, align: 'left', dataField: '' },
          ];
          updateField(field.id, { tableConfig: { ...field.tableConfig, columns: newColumns } });
        }}
        style={{ padding: '4px 10px', border: '1px solid var(--info)', color: 'var(--info)' , fontSize: '11px', cursor: 'pointer' }}
      >
        + Dodaj kolumnę
      </button>
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '8px' }}>
      {[
        { label: 'Wysokość rzędu:', prop: 'rowHeight', defaultVal: 20 },
        { label: 'Rozmiar czcionki:', prop: 'fontSize', defaultVal: 10 },
        { label: 'Czcionka nagłówka:', prop: 'headerFontSize', defaultVal: 12, specialDefault: (cfg) => (cfg?.fontSize || 10) + 2 },
        { label: 'Grubość linii:', prop: 'lineWidth', defaultVal: 0.5, step: '0.1', parser: parseFloat },
        { label: 'Wysokość nagłówka:', prop: 'headerRowHeight', defaultVal: 40, specialDefault: (cfg) => (cfg?.rowHeight || 20) * 2 },
      ].map(({ label, prop, defaultVal, step, parser = parseInt, specialDefault }) => (
        <div key={prop}>
          <label style={{ fontSize: '11px' }}>{label}</label>
          <input
            type="number"
            step={step}
            value={field.tableConfig?.[prop] ?? (specialDefault ? specialDefault(field.tableConfig) : defaultVal)}
            onChange={(e) => updateField(field.id, {
              tableConfig: { ...field.tableConfig, [prop]: parser(e.target.value) || defaultVal },
            })}
            style={{ width: '100%', padding: '3px 5px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
          />
        </div>
      ))}
    </div>

    <div style={{ marginTop: '8px', display: 'flex', gap: '10px', alignItems: 'center' }}>
      {[
        { label: 'Pokaż nagłówek', prop: 'showHeader' },
        { label: 'Pokaż ramki', prop: 'showBorders' },
      ].map(({ label, prop }) => (
        <label key={prop} style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: '3px' }}>
          <input
            type="checkbox"
            checked={field.tableConfig?.[prop] !== false}
            onChange={(e) => updateField(field.id, {
              tableConfig: { ...field.tableConfig, [prop]: e.target.checked },
            })}
          />
          {label}
        </label>
      ))}
    </div>
  </div>
);

export default TableColumnEditor;
